import script from "./confirmDeposit.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmDeposit.vue?vue&type=script&setup=true&lang=js"

import "./confirmDeposit.vue?vue&type=style&index=0&id=43cf9191&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cf9191"]])

export default __exports__